/*
 * Copyright (c) 2019 - Convergence Labs, Inc.
 *
 * This file is part of the Convergence JavaScript Client, which is released
 * under the terms of the GNU Lesser General Public License version 3
 * (LGPLv3), which is a refinement of the GNU Lesser General Public License
 * version 3 (GPLv3).  A copy of the both the GPLv3 and the LGPLv3 should have
 * been provided along with this file, typically located in the "COPYING" and
 * "COPYING.LESSER" files (respectively), which are part of this source code
 * package. Alternatively, see <https://www.gnu.org/licenses/gpl-3.0.html> and
 * <https://www.gnu.org/licenses/lgpl-3.0.html> for the full text of the GPLv3
 * and LGPLv3 licenses, if they were not provided.
 */

import {OperationTransformationFunction} from "../OperationTransformationFunction";
import {ObjectAddPropertyOperation} from "../../ops/ObjectAddPropertyOperation";
import {OperationPair} from "../OperationPair";
import {ObjectSetPropertyOperation} from "../../ops/ObjectSetPropertyOperation";

/**
 * @hidden
 * @internal
 */
export const ObjectAddPropertyAddPropertyOTF: OperationTransformationFunction<ObjectAddPropertyOperation,
  ObjectAddPropertyOperation> =
  (s: ObjectAddPropertyOperation, c: ObjectAddPropertyOperation) => {
    if (s.prop !== c.prop) {
      // O-AA-1
      return new OperationPair(s, c);
    } else if (s.value !== c.value) {
      // O-AA-2
      return new OperationPair(
        new ObjectSetPropertyOperation(s.id, s.noOp, s.prop, s.value),
        c.copy({ noOp: true }));
    } else {
      // O-AA-3
      return new OperationPair(s.copy({ noOp: true }), c.copy({ noOp: true }));
    }
  };
